import { useEffect, useState } from "react";
import { Undo2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { fetchAdminRefunds, markRefundDone } from "@/lib/api";
import { fmtPrice } from "@/lib/utils";

/* Acomptes à rembourser après annulation (remboursement manuel via CinetPay / Mobile Money). */
export const RefundsSection = () => {
  const [data, setData] = useState({ items: [], total_due: 0 });
  const [showDone, setShowDone] = useState(false);
  const load = (done = showDone) => fetchAdminRefunds(done ? "rembourse" : "a_traiter").then(setData).catch(() => {});
  useEffect(() => { load(); }, [showDone]); // eslint-disable-line react-hooks/exhaustive-deps

  const done = async (ref) => {
    try { await markRefundDone(ref); toast.success(`Remboursement ${ref} marque comme effectue`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Echec"); }
  };

  return (
    <section className="glass-card p-6 mt-8" data-testid="refunds-section">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h2 className="font-display text-xl font-extrabold inline-flex items-center gap-2"><Undo2 size={18} className="text-rose-600" /> Remboursements d&apos;acomptes</h2>
        <div className="flex items-center gap-3 text-sm">
          {!showDone && <span className="font-bold text-rose-700" data-testid="refunds-total-due">{data.count || 0} a traiter · {fmtPrice(data.total_due || 0)}</span>}
          <button onClick={() => setShowDone(!showDone)} className="chip" data-testid="refunds-toggle">{showDone ? "Voir a traiter" : "Voir rembourses"}</button>
        </div>
      </div>
      {data.items.length === 0 ? (
        <p className="text-sm text-[var(--ink-soft)] mt-3" data-testid="refunds-empty">Aucun remboursement {showDone ? "effectue" : "en attente"}.</p>
      ) : (
        <div className="overflow-x-auto mt-3">
          <table className="w-full text-sm" data-testid="refunds-table">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-[var(--ink-soft)] border-b border-[var(--line)]">
              <th className="py-2 pr-3">Ref</th><th className="py-2 pr-3">Hotel</th><th className="py-2 pr-3">Client</th><th className="py-2 pr-3">Acompte</th><th className="py-2 pr-3">Penalite</th><th className="py-2 pr-3">A rembourser</th><th className="py-2 pr-3">Annulee le</th><th className="py-2"></th>
            </tr></thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.ref} className="border-b border-[var(--line)]/60" data-testid={`refund-row-${r.ref}`}>
                  <td className="py-2 pr-3 font-mono text-xs">{r.ref}</td>
                  <td className="py-2 pr-3">{r.hotel_name}</td>
                  <td className="py-2 pr-3">{r.name}<div className="text-xs text-[var(--ink-soft)]">{r.phone}</div></td>
                  <td className="py-2 pr-3">{fmtPrice(r.deposit_amount || 0)}</td>
                  <td className="py-2 pr-3 text-rose-700">{fmtPrice(r.penalty_amount || 0)}</td>
                  <td className="py-2 pr-3 font-bold text-emerald-700">{fmtPrice(r.refund_amount || 0)}</td>
                  <td className="py-2 pr-3 text-xs">{r.cancelled_at ? new Date(r.cancelled_at).toLocaleString("fr-FR") : "—"}</td>
                  <td className="py-2">
                    {r.refund_status === "a_traiter" ? (
                      <button onClick={() => done(r.ref)} className="btn-primary !py-1.5 !px-3 text-xs inline-flex items-center gap-1" data-testid={`refund-done-${r.ref}`}><CheckCircle2 size={13} /> Rembourse</button>
                    ) : <span className="text-xs text-emerald-700 font-bold">Rembourse{r.refunded_at ? ` le ${new Date(r.refunded_at).toLocaleDateString("fr-FR")}` : ""}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
